import { InfoPage } from '@/components/info-page.js';
import { useSession } from '@/auth/useSession.js';
import { isEdgeCoach } from '@airreading/common';
import { CoachProfileForm } from './coach-profile-form.js';
import { ProfileFormProps } from './profile-form.js';
import { CoachPaymentForm } from './coach-payment-form.js';

export const CoachPage = (props: ProfileFormProps) => {
  const { actingUser } = useSession();
  return (
    <InfoPage headerText="Account">
      <CoachProfileForm {...props} />
      {actingUser && !isEdgeCoach(actingUser) && <CoachPaymentForm />}
    </InfoPage>
  );
};
